import React from 'react';
import '../../pages/Project/ProjectPage.css'
import { Link } from 'react-router-dom';
import { ButtomGet } from '../ButtomGet/ButtomGet';

/* Multi idioma */
import { FormattedMessage } from 'react-intl';

/* Swiper */
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper";

/* Img */
const proyectImg = require.context('../../img', true);

const Project = () => {
    return (
        <section className="proyectos" id="proyectos">
            <h2 className="heading">
                <FormattedMessage
                    id='projects'
                    defaultMessage='Projects'
                />
            </h2>
            <div className="proyect-site" data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
                <Swiper
                    spaceBetween={30}
                    loop={true}
                    grabCursor={true}
                    centeredSlides={true}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    modules={[Pagination, Autoplay]}
                    breakpoints={{
                        0: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 3,
                        },
                    }}
                    className='proyectos-slider mySwiper'
                >
                    <SwiperSlide className='caja'>
                        <img
                            src={proyectImg(`./proyecto-app-18.png`)}
                            alt='proyectos'

                        />
                        <div className="content">
                            <h3>Deadbear Agency</h3>
                            <p>
                                $SCUM burning website
                            </p>
                            <p className="tecnologias">
                                React
                                <span> -</span> Styled Components
                                <span> -</span> TypeScript
                                <span> -</span> Solana
                                <span> -</span> Web3
                                <span> -</span> NodeJS
                                <span> -</span> MongoDB
                            </p>
                            <a href="https://deadbearinc.agency/" className="custom-btn btn" target="_blank" rel="noopener noreferrer"><span>Demo</span></a>
                            {/* <a href="https://github.com/lucky-whistle-dev/deadbear-fe" className="custom-btn btn-codigo" target="_blank" rel="noopener noreferrer">Repository</a> */}
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className='caja'>
                        <img
                            src={proyectImg(`./proyecto-14.jpg`)}
                            alt='proyectos'

                        />
                        <div className="content">
                            <h3>Mirage Token Launchpad</h3>
                            <p>
                               Spl Token Launchpad
                            </p>
                            <p className="tecnologias">
                                NextJS
                                <span> -</span> Tailwind CSS
                                <span> -</span> TypeScript
                                <span> -</span> Solana
                                <span> -</span> Web3
                                <span> -</span> Rust

                            </p>
                            <a href="https://www.miragelaunchpad.xyz/" className="custom-btn btn" target="_blank" rel="noopener noreferrer"><span>Demo</span></a>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className='caja'>
                        <img
                            src={proyectImg(`./proyecto-app-17.png`)}
                            alt='proyectos'

                        />
                        <div className="content">
                            <h3>Foster Marketplace</h3>
                            <p>
                                Nft Marketplace
                            </p>
                            <p className="tecnologias">
                                NextJS
                                <span> -</span> Tailwind CSS
                                <span> -</span> NodeJS
                                <span> -</span> ExpressJS
                                <span> -</span> Solana
                                <span> -</span> Web3
                                <span> -</span> Rust
                                <span> -</span> PostgreSQL
                            </p>
                            <a href="https://fostermarketplace.app/" className="custom-btn btn" target="_blank" rel="noopener noreferrer"><span>Demo</span></a>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className='caja'>
                        <img
                            src={proyectImg(`./proyecto-7.jpg`)}
                            alt='proyectos'
                        />
                        <div className="content">
                            <h3>SMOG Staking Webiste</h3>
                            <p>
                                Token Staking Website
                            </p>
                            <p className="tecnologias">
                                Angular
                                <span> -</span> JavaScript
                                <span> -</span> Bootstrap
                                <span> -</span> AWS
                                <span> -</span> Solana, Ethereum
                                <span> -</span> Web3
                            </p>
                            <a href="https://smogtoken.com/en/staking" className="custom-btn btn" target="_blank" rel="noopener noreferrer"><span>Demo</span></a>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className='caja'>
                        <img
                            src={proyectImg(`./proyecto-6.jpg`)}
                            alt='proyectos'
                        />
                        <div className="content">
                            <h3>Rising Legends Website</h3>
                            <p>
                                Nft Whitelist
                            </p>
                            <p className="tecnologias">
                                NuxtJS
                                <span> -</span> TailwindCSS
                                <span> -</span> Google Cloud
                                <span> -</span> Solana
                                <span> -</span> Web3
                            </p>
                            <a href="https://coingamesnfts.com/" className="custom-btn btn" target="_blank" rel="noopener noreferrer"><span>Demo</span></a>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className='caja'>
                        <img
                            src={proyectImg(`./proyecto-12.jpg`)}
                            alt='proyectos'
                        />
                        <div className="content">
                            <h3>DedDoods</h3>
                            <p>
                                Nft/Token Staking/Mint Website
                            </p>
                            <p className="tecnologias">
                                HTML5
                                <span> -</span> Bootstrap5
                                <span> -</span> jQuery
                                <span> -</span> GSAP
                                <span> -</span> Ethereum
                                <span> -</span> Web3
                                <span> -</span> Solidity
                            </p>
                            <a href="https://doodcats.net/" className="custom-btn btn" target="_blank" rel="noopener noreferrer"><span>Demo</span></a>
                        </div>
                    </SwiperSlide>
                </Swiper>
                <div className="swiper-pagination"></div>
            </div>
            {/* <Link className="custom-btn btn-codigo portafolio-btn" to="/project">
                <FormattedMessage
                    id='btn-more-projects'
                    defaultMessage='More projects'
                />
            </Link> */}
            {/* <div className='portafolio-btn'>
                <Link to="/project">
                    <ButtomGet/>
                </Link>
            </div> */}
        </section>

    )
};
export default React.memo(Project);